import React from 'react'
import moment from 'moment'
import { Card, Button, List, Label } from 'semantic-ui-react'

const styles = {
  listContentWrapper: {
    display: 'flex',
    padding: '3px 0px',
    alignItems: 'center',
  },
}

const Row = ({ field, value }) => {
  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ flex: 1 }}>{field}</div>
        <Label size="medium">
          {value}
        </Label>
      </List.Content>
    </List.Item>
  )
}

const QtyPromotionCard = ({ promotion, onEdit, onDelete }) => {
  const startedDate = moment(promotion.started_at).format('DD-MMM-YYYY')
  const endedDate = moment(promotion.ended_at).format('DD-MMM-YYYY')

  return (
    <Card style={{ marginLeft: 30 }}>
      <Card.Content>
        <Card.Header>{promotion.title}</Card.Header>

        <Card.Description>
          <List divided verticalAlign="middle" style={{ marginTop: 10 }}>
            <Row field="Merchant" value={promotion.merchant_name} />
            <Row field="Branch" value={promotion.branch_name} />
            <Row field="Started at" value={startedDate} />
            <Row field="Ended at" value={endedDate} />
          </List>
        </Card.Description>
      </Card.Content>

      <Card.Content extra style={{ display: 'flex' }}>
        <Button
          size="tiny"
          color="black"
          content="Edit"
          onClick={onEdit}
          style={{ width: '100%' }}
        />
        <Button
          size="tiny"
          color="red"
          content="Delete"
          onClick={onDelete}
          style={{ width: '100%' }}
        />
      </Card.Content>
    </Card>
  )
}

export default QtyPromotionCard


// WEBPACK FOOTER //
// ./src/containers/promotions/components/QuantityPromotions/Card.js